import React, { useEffect, useRef, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';

interface MarqueeProps {
  children: any;
  direction?: 'left' | 'right' | 'up' | 'down'; // 이동 방향
  speed?: number; // 속도 (초 단위)
  style?: React.CSSProperties; // 추가 스타일
  wrapperWidth?: number;
}

// 방향에 따른 애니메이션 정의
const marqueeHorizontal = (wrapperWidth: number) => keyframes`
  0% {
    transform: translateX(${wrapperWidth}px);
  }
  100% {
    transform: translateX(-100%);
  }
`;

// `styled-components`로 컴포넌트 스타일 정의
const MarqueeWrapper = styled.div`
  overflow: hidden; /* 텍스트가 상위 박스 밖으로 넘어가지 않도록 */
  width: 100%;
  white-space: nowrap;
  padding: 8px 0;
  font-size: 14px;
  position: relative; /* MarqueeContent를 중앙에 위치시키기 위해 필요 */
  height: 50px; /* 원하는 높이 설정 */
  display: flex; /* 중앙 정렬을 위한 Flexbox 사용 */
  align-items: center; /* 세로 중앙 정렬 */
`;

const MarqueeContent = styled.div<MarqueeProps>`
  position: absolute;
  color: var(--subTextColor);
  ${(props) => css`
    animation: ${marqueeHorizontal(props.wrapperWidth || 100)} ${props.speed}s
      linear infinite;
  `};
`;

const Marquee = ({
  children,
  direction = 'left',
  speed = 30,
  style,
}: MarqueeProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [wrapperWidth, setWrapperWidth] = useState(0);

  useEffect(() => {
    if (wrapperRef.current) {
      setWrapperWidth(wrapperRef.current.offsetWidth);
    }
  }, [wrapperRef]);

  return (
    <MarqueeWrapper style={style} ref={wrapperRef}>
      <MarqueeContent
        wrapperWidth={wrapperWidth}
        direction={direction}
        speed={speed}
      >
        {children}
      </MarqueeContent>
    </MarqueeWrapper>
  );
};

export default Marquee;
